import React, { PropsWithChildren, ReactElement } from 'react';
import Menu from '../menu';
import Footer from '../footer';
import NavBar from '../nav_bar';
import TopBar from '../top_bar';
import RestrictionContainer from '../../containers/Restriction';
import './Layout.scss';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="vrr-layout">
      <TopBar />
      <Menu />
      <div className="vrr-content">
        <NavBar
          elements={
            (children as ReactElement)?.props?.routerProps?.navBarElements
          }
        />
        <div className="locate-children">{children}</div>
      </div>
      <Footer />
      <RestrictionContainer />
    </div>
  );
};

export default Layout;
